import React, { Component } from 'react';
type JSXElement = React.ReactElement<any, string | React.JSXElementConstructor<any>>;
import PropTypes from 'prop-types';
import { QueryParams } from '../../util/getQueryParams';
import { FilterOptions } from './Search';

const monthLabels: string[] = [
  'januari',
  'februari',
  'maart',
  'april',
  'mei',
  'juni',
  'juli',
  'augustus',
  'september',
  'oktober',
  'november',
  'december',
];

// as defined in SearchFilterControls.js
const distances: { [distance: number]: string } = {
  11: 'Minder dan 10 km',
  27: 'Minder dan 25 km',
  55: 'Minder dan 50 km',
  105: 'Minder dan 100 km',
  155: 'Minder dan 150 km',
};

interface ComponentProps {
  queryParams: QueryParams;
  filterOptions: FilterOptions;
}

/**
 * shows the active filters as tags on top of the page (mobile only)
 */
export class SearchResultsActiveFilters extends Component<ComponentProps> {

  /**
   * Extracts the active/useful labels from the filterOptions and query params.
   */
  public setLabels(): string[] {
    let { queryParams, filterOptions } = this.props;
    let activeFilters: string[] = [];

    // set level label. (e.g. HAVO).
    if (queryParams.level && queryParams.level.length > 0) {
      activeFilters.push(queryParams.level as string);
    }

    // set subjects array as labels. (e.g. Biologie).
    if (queryParams.subject && Array.isArray(queryParams.subject)) {
      queryParams.subject.forEach((subject: string) => activeFilters.push(subject));
    }

    // Set city as label (e.g. Den Haag).
    if (queryParams.city) {
      activeFilters.push(queryParams.city as string);
    }

    // Set distance label (e.g. Minder dan 50 km).
    if (filterOptions.filter.distance) {
      const label = distances[filterOptions.filter.distance];

      if (label) {
        activeFilters.push(label);
      }
    }

    // Set month label (e.g. november).
    if (filterOptions.filter.month) {
      // split the string (e.g. 2011-02).
      const month: string = filterOptions.filter.month.split('-')[1];
      const monthIndex: number = parseInt(month, 10) - 1;
      activeFilters.push(monthLabels[monthIndex]);
    }

    // Set type label (e.g. Examentraining weekend).
    if (filterOptions.filter.type) {
      activeFilters.push(filterOptions.filter.type);
    }

    return activeFilters;
  }

  public render(): JSX.Element {
    const activeFilters = this.setLabels();

    const badges = (
      activeFilters.map((filter, key) => {
        return (
          <span key={key} className="label search-results__active-filters-label">
            {filter}
          </span>
        );
      })
    );

    if (badges.length > 0) {
      return (
        <div className="search-results__active-filters visible-xs">
          <div className="search-results__active-filters-title">
            Resultaten voor
          </div>
          {badges}
        </div>
      );
    }

    return null;
  }
}
